import { NotificationType } from '../types/notification-type';
import { addNotificationByType } from './add-notification-by-type';
export const addSuccessNotification = (notificationDetails, internalActions) => {
    addNotificationByType(notificationDetails, NotificationType.Success, internalActions);
};
//# sourceMappingURL=add-success-notification.js.map